import { PureComponent } from 'react';
import BrowserService from '../services/helper/browserService';

const isDesktop = !BrowserService.isMobileOrTabled();

function detectWebcam(callback) {
    let md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) return callback(false);
    md.enumerateDevices()
        .then(devices => {
            const hasDevice = devices.some(device => 'videoinput' === device.kind);
            if (hasDevice) {
                let constraints = { audio: true, video: true };
                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(() => callback(true))
                    .catch(err => {
                        callback(false);
                    });
            }
        })
        .catch(() => {
            callback(false);
        });
}

/**
 * IF THIS IS NOT A DESKTOP DEVICE WE RETURN THE CONTENTS WITHOUT CHANGES
 * IF IT'S A DESKTOP DEVICE AND NO CAMERA ENABLED, WE HIDE THE CONTENT
 * IF IT'S A DESKTOP DEVICE AND CAMERA ENABLED, WE SHOW THE CONTENT
 */
export default class DesktopCameraEnabled extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            cameraAvailable: window.IS_CAMERA_PRESENT || false, // cache camera availability
        };
    }

    componentDidMount() {
        if (isDesktop) {
            detectWebcam(value => {
                this.setState({
                    cameraAvailable: value,
                });
                window.IS_CAMERA_PRESENT = value;
            });
        }
    }

    render() {
        if (!isDesktop) return this.props.children;
        if (isDesktop && !this.state.cameraAvailable) return null;
        return this.props.children;
    }
}
